import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import { useMemo } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const contactListIds = {
    eu: '926148913',
    uk: '2109435518',
    de: '1061412141',
    fr: '774048908',
    it: '1152966046',
    es: '1399480182',
};

export default function Comp() {
    const { locale = 'eu' } = getLocal();
    const { t } = useLang('theProduct.SectionB');

    const fields = useMemo(() => {
        const EU_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '7596', value: [43], overwrite: false },
            { type: 'multiple', id: '9690', value: [12], overwrite: false },
        ];
        switch (locale) {
            case 'de':
                return [{ type: 'single', id: '4425', value: 1, overwrite: true }, ...EU_Fields];
            case 'es':
                return [{ type: 'single', id: '4426', value: 1, overwrite: true }, ...EU_Fields];
            case 'eu':
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
            case 'fr':
                return [{ type: 'single', id: '4428', value: 1, overwrite: true }, ...EU_Fields];
            case 'it':
                return [{ type: 'single', id: '4429', value: 1, overwrite: true }, ...EU_Fields];
            case 'uk':
                return [{ type: 'single', id: '4430', value: 1, overwrite: true }, ...EU_Fields];
            default:
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
        }
    }, [locale]);

    // 邮件
    const termsHtml = useMemo(() => {
        switch (locale) {
            case 'eu':
                return `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html" target="_blank">Terms of Service</a>.`;
            case 'uk':
                return `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-uk/PrivacyPolicy.html" target="_blank">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html" target="_blank">Terms of Service</a>.`;
            case 'de':
                return `Ich akzeptiere die <a href="https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html" target="_blank">Datenschutzbestimmungen</a> und <a href="https://account.ecoflow.com/agreement/de-de/TermsOfUse.html" target="_blank">Nutzungsbedingungen</a> von EcoFlow.`;
            case 'fr':
                return `J'accepte la <a href="https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html" target="_blank">Politique de confidentialité</a> et les <a href="https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html" target="_blank">Conditions d'utilisation</a> d'EcoFlow.`;
            case 'it':
                return `Accetto l’<a href="https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html" target="_blank">Informativa sulla privacy</a> e i <a href="https://account.ecoflow.com/agreement/it-it/TermsOfUse.html" target="_blank">Termini di servizio</a> di EcoFlow.`;
            case 'es':
                return `Acepto la <a href="https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html" target="_blank">Política de privacidad</a> y los <a href="https://account.ecoflow.com/agreement/es-es/TermsOfUse.html" target="_blank">Términos de servicio</a> de EcoFlow.`;
            default:
                return undefined;
        }
    }, [locale]);

    return (
        <div className={styles.comp} id="SectionB">
            <EcoSpaceSmall />
            <div className="container">
                <div className="title">{t.rich('title', { h: (v: string) => <span>{v}</span> })}</div>
                <EcoEmail
                    contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.eu]}
                    source="WEB_NEW_PRODUCT_SUB"
                    fields={fields}
                    termsHtml={termsHtml}
                    tipsObj={{
                        placeholder: t('placeholder'),
                        tipsCheck: t('tipsCheck'),
                        successTips: t('successTips'),
                    }}
                    needTerms
                    subscribeData={{
                        sector_name: 'EcoFlow GLACIER Classic',
                        entry_position: 3,
                    }}
                />
            </div>
            <EcoSpace />
        </div>
    );
}
